import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useGetAcceptanceRate = (code, params) => {
  const {
    filters: { associationType = '', startDate = '', endDate = '' }
  } = params;

  return useQuery(
    [`${associationType}AcceptanceRate`, code, associationType, startDate, endDate],
    () =>
      services.getAcceptanceRate(
        code,
        cleanObjectEmptyFields({
          filters: {
            associationType,
            startDate,
            endDate
          }
        })
      ),
    {
      enabled: !!code
    }
  );
};
